import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Region } from '../model/region.model';

const baseUrl = `/api/regions`;

@Injectable({ providedIn: 'root' })
export class RegionClient {
    private _httpClient = inject(HttpClient);

    list() {
        return this._httpClient.get<Region[]>(`${baseUrl}`);
    }
}
